<template>
    <div>

        <ul id="nav_list" class="nav flex-column nav-pills">
            <li class="nav-item">
                <router-link :to="{name: `adoption-status`}" class="nav-link">
                    Adoption
                </router-link>
            </li>

<!--            <li class="nav-item">-->
<!--                <router-link :to="{name: `adoption-previous`}" class="nav-link">-->
<!--                    Previous-->
<!--                </router-link>-->
<!--            </li>-->

            <li class="nav-item">
                <router-link :to="{path: `/adoption/${customerId}/contact/${companyId}`}" class="nav-link">
                    Contacts
                </router-link>
            </li>

            <li class="nav-item">
                <router-link :to="{path: `/adoption/${customerId}/update`}" class="nav-link">
                    Update
                </router-link>
            </li>
        </ul>
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";
</style>

<script>
import { mapState } from 'vuex'

export default {
    name: "AdoptionLeftNav",
    computed: mapState({
        customerId: state => state.adoption.adoptionData.customer_id,
        companyId: state => state.adoption.adoptionData.company_id,
    }),
    mounted () {
    }
}
</script>
